import type { RedoProceduresRpcClient } from "@redotech/redo-merchant-procedures-rpc/client";
import { createRedoProceduresRpcClient } from "@redotech/redo-merchant-procedures-rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoProceduresRpcClientContext: Context<
  RedoProceduresRpcClient | undefined
> = createContext<RedoProceduresRpcClient | undefined>(undefined);

RedoProceduresRpcClientContext.displayName = "RedoProceduresRpcClientContext";

export interface RedoProceduresRpcClientProviderProps {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}

export function RedoProceduresRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: RedoProceduresRpcClientProviderProps) {
  const client = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoProceduresRpcClient({
      baseURL: new URL(`${baseUrl}/procedures-rpc`),
      headers: { Authorization: authToken },
    });
  }, [baseUrl, authToken]);

  return (
    <RedoProceduresRpcClientContext.Provider value={client}>
      {children}
    </RedoProceduresRpcClientContext.Provider>
  );
}
